module.exports = __webpack_public_path__ + "static/media/kevin_durant.2bfeb2a9.png";